import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ExpandFirstItemDirective } from '../../../field-editor/directives/expand-first-item.directive'
import { EditorInputField } from '../../../../editor-container/editor-model';

@Component({
  selector: 'kve-home-input-default',
  templateUrl: './home-input-default.component.html',
  styleUrls: ['./home-input-default.component.scss']
})
export class HomeInputDefaultComponent implements OnInit {


  fields: EditorInputField[] = [
    {
      name: "background",
      title: "Background",
      type: "background",
      controlType: 'color-picker'
    },
    {
      name: "width",
      title: "Width",
      type: 'width',
      controlType: 'singleMeasure'
    },
    {
      name: 'padding',
      title: 'Padding',
      type: 'padding',
      controlType: 'multiMeasure'
    },
    {
      name: "margin",
      title: "Margin",
      type: "margin",
      controlType: "multiMeasure"
    },
    {
      name: 'border',
      title: "Border",
      type: "border",
      controlType: "multiMeasure"
    },
    {
      name: "seo",
      title: "SEO",
      type: "group",
      controlType: 'dialog'
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
